module.exports = __webpack_public_path__ + "static/media/BenefitCross.b05a9acb.svg";